module.exports = __webpack_public_path__ + "static/img/header-bg.7161b936.png";